import { useI18n } from "../i18n";
const MIN = 87.5;
const MAX = 108;
const rdsText = (tuned, active, count, t) => {
  if (tuned) return `RDS › ${tuned.toUpperCase()}`;
  if (active) return "RDS › ---";
  return t("realStations", { n: count });
};
const pos = (f) => ((f - MIN) / (MAX - MIN)) * 100;

export const FrequencyDial = ({ freq, active, stations = [], tuned }) => {
  const { t } = useI18n();
  const ticks = Array.from({ length: 42 }, (_, i) => i);
  return (
    <div className="panel p-5" data-testid="frequency-panel">
      <div className="flex items-end justify-between mb-4 gap-4">
        <div>
          <span className="label">{t("freq")}</span>
          <p className={`font-mono text-xs mt-2 tracking-widest ${tuned ? "text-amber" : "text-subtle"}`} data-testid="tuned-station">
            {rdsText(tuned, active, stations.length, t)}
          </p>
        </div>
        <span className={`font-mono font-bold tracking-widest text-4xl sm:text-5xl text-cyan glow-cyan ${active ? "" : "opacity-40"}`} data-testid="ghost-frequency-display">
          {freq.toFixed(1)}<span className="text-base ml-2 text-muted">MHz</span>
        </span>
      </div>
      <div className="relative h-14 border-t border-b border-line overflow-hidden">
        <div className="absolute inset-0 flex justify-between items-end px-1">
          {ticks.map((i) => (
            <div key={i} className={`w-px bg-subtle ${i % 5 === 0 ? "h-8 bg-muted" : "h-4"}`} />
          ))}
        </div>
        {stations.map((s) => (
          <div key={s.url} title={`${s.name} · ${s.freq}`} className={`absolute top-0 w-[3px] h-4 -translate-x-1/2 ${tuned === s.name ? "bg-amber shadow-amber" : "bg-cyan opacity-70"}`} style={{ left: `${pos(s.freq)}%` }} data-testid="station-marker" />
        ))}
        <div className="absolute top-0 bottom-0 w-[2px] bg-amber shadow-amber" style={{ left: `${pos(freq)}%`, transition: "left 80ms linear" }} data-testid="frequency-needle" />
      </div>
      <div className="flex justify-between font-mono text-xs text-subtle mt-2">
        {[88, 92, 96, 100, 104, 108].map((n) => <span key={n}>{n}</span>)}
      </div>
    </div>
  );
};
